import React from 'react';
import CoinItem from './CoinItem';
import type { CoinData } from '../types/interfaces';

interface CoinListProps {
  coins: CoinData[];
  onCoinClick: (coinId: string) => void;
  isInWatchlist?: (coinId: string) => boolean;
  onWatchlistToggle?: (coinId: string) => void;
  currency?: string;
}

export default function CoinList({ coins, onCoinClick, isInWatchlist, onWatchlistToggle, currency }: CoinListProps) {
  if (coins.length === 0) {
    return (
      <div className="text-center py-14 px-5 text-text-secondary text-lg">
        No cryptocurrencies found.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {coins.map(coin => (
        <CoinItem 
          key={coin.id} 
          coin={coin} 
          onClick={() => onCoinClick(coin.id)}
          isInWatchlist={isInWatchlist ? isInWatchlist(coin.id) : false}
          onWatchlistToggle={onWatchlistToggle}
          currency={currency}
        />
      ))}
    </div>
  );
}

